export const urlMapping = {
    'web-hosting':'emprende',
    'web-hosting-negocio':'pymes',
    'hosting-negocio-wordpress':'wordpress',
    'web-hosting-empresa':'empresa',
    'certificados-ssl':'ssl',
    'vps-con-backup': 'vps-back'
}